module.exports = __webpack_public_path__ + "img/Avatar-21.2ed4df01.gif";